import { sessionReducer } from '../../session/reducers/SessionReducer';
import sessionSaga from '../../session/sagas/SessionSagas';
const loadSessionModule = () => ({
    id: 'Session',
    reducerMap: {
        session: sessionReducer,
    },
    sagas: [sessionSaga],
});
export default loadSessionModule;
